import { render, staticRenderFns } from "./LogAndNotice.vue?vue&type=template&id=34f53f80"
import script from "./LogAndNotice.vue?vue&type=script&lang=js"
export * from "./LogAndNotice.vue?vue&type=script&lang=js"
import style0 from "./LogAndNotice.vue?vue&type=style&index=0&id=34f53f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports